import { useState, useEffect } from 'react';
import api from '../api';

export default function EditBlog({ blog, onClose, onUpdated }) {
  const [form, setForm] = useState({
    title: blog.title,
    description: blog.description,
    imageUrl: blog.imageUrl,
    content: blog.content
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    try {
      await api.put(`/blogs/${blog.id}`, form);
      onUpdated(); // refresh list
      onClose();   // close modal
    } catch (err) {
      console.error('Error updating blog:', err);
    }
  };

  // Allow closing modal with Escape key
 useEffect(() => {
  const handleKey = (e) => {
    if (e.key === 'Escape') onClose();
  };
  window.addEventListener('keydown', handleKey);
  return () => window.removeEventListener('keydown', handleKey);
}, [onClose]);



  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      <div className="pointer-events-auto bg-black bg-opacity-50 flex items-center justify-center w-full h-full">
        <div className="bg-white p-6 rounded shadow-lg w-full max-w-lg dark:bg-gray-800 dark:text-gray-100">
          <h2 className="text-xl font-bold mb-4 dark:text-blue-500">Edit Blog</h2>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            className="w-full mb-2 p-2 border dark:text-black"
            placeholder="Title"
          />
          <input
            name="description"
            value={form.description}
            onChange={handleChange}
            className="w-full mb-2 p-2 border dark:text-black"
            placeholder="Description"
          />
          <input
            name="imageUrl"
            value={form.imageUrl}
            onChange={handleChange}
            className="w-full mb-2 p-2 border dark:text-black"
            placeholder="Image URL"
          />
          <textarea
            name="content"
            value={form.content}
            onChange={handleChange}
            className="w-full mb-2 p-2 border h-32 dark:text-black"
            placeholder="Content"
          />
          <div className="flex justify-end space-x-2 mt-4">
            <button onClick={onClose} className="text-gray-600">Cancel</button>
            <button onClick={handleUpdate} className="text-blue-600">Update</button>
          </div>
        </div>
      </div>
    </div>
  );
}